<template>
    <page-main tag="main" class="wrapper--page microsite--scholarship">
        <transition name="fade" mode="out-in">

            <Loader v-if="!isLoaded" />

        </transition>
        
        <transition appear name="fade" mode="out-in">
            <Builder :sections="microsite.sections" />
        </transition>

        <SlideLines />

        <PageCtas />
        <PageFooter />
            
    </page-main>
</template>

<script>
import { gsap } from 'gsap'
import { focusOrderWatcher } from '@/mixins/focusOrder'
import { page } from '@/data/scholarship.js'

import Loader from '@/components/Loader'
import Builder from '@/components/Builder/Builder.vue'
import SlideLines from '@/components/Slide/SlideLines'
import PageFooter from '@/components/PageFooter.vue'
import PageCtas from '@/components/Discover/PageCtas'

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
    name: 'CampusMicrosite',
    metaInfo() {
        return {
            title: this.microsite.title ? this.microsite.title : undefined
        }
    },

    components: {
        Loader,
        Builder,
        SlideLines,
        PageCtas,
        PageFooter,
    },

    mixins: [
        focusOrderWatcher,
    ],

    data: () => ({
        isLoaded: false,
    }),

    beforeRouteUpdate(to, from, next) {
        gsap.set(document.body, {
            scrollTop: 0,
            onComplete: next
        })
    },

    activated() {
        this.$nextTick(() => {
            gsap.set(document.body, {
                scrollTop: 0,
                onComplete: async () => {
                    await sleep(200)
                    this.isLoaded = true
                }
            })
        })
    },

    computed: {
        microsite() {
            return {
                title: page && page.title ? page.title.rendered || page.title : '',
                sections: page && page.sections ? page.sections || [] : []
            }
        },
    },
}
</script>

<style scoped lang="scss">
::v-deep .section-columns:has(.section__number-column) {
    padding-block: 0;
}
::v-deep .section-text + .section-text {
    padding-block-start: 0;
}
</style>